// apps/admin/src/features/support/SupportTicketListener.tsx
//
// dbg-20260705-ticket-realtime-notify — render-less global mount for support
// ticket realtime (sidebar badge + sound/desktop/tab-flash on new tickets).
// Sibling of SystemEventListener; mount once inside the authenticated shell.

import type { JSX } from 'react';

import { useSupportTicketRealtime } from './useSupportTicketRealtime.js';

export function SupportTicketListener(): JSX.Element {
  useSupportTicketRealtime();
  return (
    <span
      aria-hidden="true"
      data-testid="support-ticket-listener"
      className="sr-only"
    />
  );
}

export default SupportTicketListener;
